import { Button } from "@material-ui/core";
import { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import axios from "axios";
import "./QuizResults.css";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

const QuizResult = ({ quiz, section }) => {
  const [result, setResult] = useState([]);
  const [open, setOpen] = useState(false);
  const [record, setRecords] = useState();

  const handleOpen = (id) => {
    setOpen(true);
    setRecords(result.find(row => row._id === id));
  };

  const handleClose = () => {
    setOpen(false);
  };
  
  
  const useStyles = makeStyles((theme) => ({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    table: {
      minWidth: 550
    },
    container: {
      maxHeight: 450,
    }
  }));
  
  const classes = useStyles();

  useEffect(() => {
    const getResult = async () => {
      const { data } = await axios.get(`https://computer-quiz-backend.herokuapp.com/quizzes/${quiz}/results?year_section=${section}`,
        {
          headers: { 'api-token': localStorage.getItem('token') }
        }
      );
      setResult(data);
    };
    getResult();
  }, [quiz, section]);

  return (
    <div className="quizContent">
      <div className="quizSetting">
        <span style={{ fontSize: 30 }}>Quiz Results</span>
        { result.length !== 0 &&
          <div className="settings__quiz">
            <TableContainer className={classes.container} component={Paper}>
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: '45%' }}>Name</TableCell>
                    <TableCell>Score</TableCell>
                    <TableCell>Activities</TableCell>
                    <TableCell>Date/Time Started</TableCell>
                    <TableCell>Date/Time Finished</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {result.map((row) => (
                    <TableRow key={row.full_name}>
                      <TableCell component="th" scope="row">
                        {row.full_name}
                      </TableCell>
                      <TableCell>{row.score === 999 ? 'pending' : row.score}</TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={() => handleOpen(row._id)}
                        >
                          View Activities
                        </Button>
                      </TableCell>
                      <TableCell>{new Date(row.createdAt).toLocaleDateString()} {new Date(row.createdAt).toLocaleTimeString()}</TableCell>
                      <TableCell>{new Date(row.updatedAt).toLocaleDateString()} {new Date(row.updatedAt).toLocaleTimeString()}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        }
      </div>
      <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <h2 style={{ textAlign: 'center' }}>Activities</h2>
              { record && record.activities.length ?
              record.activities.map(act => (
                <div>
                  <span>{new Date(act.timestamp).toLocaleDateString()} {new Date(act.timestamp).toLocaleTimeString()} - {act.action}</span>
                </div>
              )) : <span>No result</span>
              }
            </div>
          </Fade>
        </Modal>
    </div>
  );
};

export default QuizResult;
